//import liraries
import React, { Component, useState } from "react";
import { View, Text, StyleSheet, Pressable, Image } from "react-native";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  maxSize,
} from "rn-responsive-styles";
import CServiceReqBoxView from "../../common/CServiceReqBoxView";
import Common from "../../common/Common";
import { updateMobile } from "../../api/serviceRequest";
import ModalAlert from "../../common/ModalAlert";
import Loader from "../../common/Loader";
import RootNavigation from "../../utilities/RootNavigation";

// create a component
const MobileNumberUpdate = (props) => {
  const mobileRegex = /^([6-9]{1})([0-9]{9})/g;
  const styles = useStyles();
  const [mobileNumber, setMobileNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const [alertModalVisible, setAlertModalVisible] = useState(false);
  const [alertModal, setAlertModal] = useState({
    title: "",
    status: "",
    message: "",
    navigateScreen: "",
    actionButton: "",
  });

  const onCloseModal = () => {
    setAlertModalVisible(false);
    if (alertModal.status == "request_initiated") {
      RootNavigation.navigate("serviceRequest");
    }
  };

  const updateMobileNumber = () => {
    setLoading(true);
    let params = {
      newMobileNo: mobileNumber,
    };

    updateMobile(params)
      .then((res) => {
        setLoading(false);
        if (res?.statusCode == 200) {
          setMobileNumber("");
          setAlertModalVisible(true);
          setAlertModal({
            title: "Request Initiated",
            status: "request_initiated",
            message: res.message,
            navigateScreen: "service request",
            actionButton: "OK",
          });
        } else {
          setLoading(false);
          setAlertModalVisible(true);
          setAlertModal({
            title: "Error",
            status: "error",
            message: res.message,
            navigateScreen: "",
            actionButton: "OK",
          });
        }
      })
      .catch((err) => {
        setLoading(false);
        setAlertModalVisible(true);
        setAlertModal({
          title: "Error",
          status: "error",
          message: err?.message,
          navigateScreen: "",
          actionButton: "OK",
        });
      });
  };

  return (
    <View style={styles.container}>
      <View style={styles.SvcRq_Body_row1}>
        <View style={styles.SvcRq_Body_row1_headingTextHelper}>
          <Text style={styles.SvcRq_Body_row1_headingText}>
            Mobile number update
          </Text>
        </View>
        <View style={styles.SvcRq_Body_row1_bottomTextHelper}>
          <Text style={styles.SvcRq_Body_row1_bottomText}>
            Use this panel to update your mobile number
          </Text>
        </View>
      </View>
      <View style={styles.contentViewStyle}>
        <View style={styles.SvcRq_InfoCard}>
          <View style={styles.SvcRq_InfoCardContent}>
            <Text style={styles.SvcRq_InfoCard_headingText}>
              Update mobile number
            </Text>
            <Common.mobileDescTextView text="Make sure your new phone number can receive SMS or phone calls and has an active cellular connection." />

            <View style={{ marginVertical: 20 }}>
              <Common.mobileDescTextView text="An SMS will be sent to your new number containing DigiLocker Verification link" />
            </View>
            <Common.mobileDescTextView text="After successful DigiLocker verification your mobile number will be updated" />
          </View>
        </View>
        <View style={styles.contentTwoStyle}>
          <CServiceReqBoxView
            descText={
              "Please enter the new mobile number you want to add to this FASTag account and click submit"
            }
            selectedLayout={"Update mobile number"}
            value={mobileNumber}
            onChangeText={(e) => setMobileNumber(e.replace(/[^0-9]/gi, ""))}
            placeHolder={"Enter Mobile Number"}
            onSubmitPress={updateMobileNumber}
            disable = {!mobileRegex.test(mobileNumber)}
          />
        </View>
      </View>
      {alertModalVisible ? (
        <View style={styles.overlayViewStyle}>
          <ModalAlert
            title={alertModal.title}
            status={alertModal.status}
            message={alertModal.message}
            navigateScreen={alertModal.navigateScreen}
            actionButton={alertModal.actionButton}
            onCloseModal={onCloseModal}
          />
        </View>
      ) : null}
      {loading && <Loader />}
    </View>
  );
};

// define your styles
const useStyles = CreateResponsiveStyle(
  {
    container: {
      marginLeft: 40,
      height: 300,
    },
    SvcRq_InfoCard: {
      width: 257,
      height: "100%",
      borderRadius: 12,
      padding: 10,
      marginRight: 20,
      backgroundImage:
        "linear-gradient(to right, #F8EBEC, #F8EBEC, #fff 94%, rgba(94, 94, 94, 0) 108%)",
      border: "1px solid #ff6e6e",
      flexDirection: "row",
    },
    contentTwoStyle: { width: "67%" },
    contentViewStyle: { flexDirection: "row", marginTop: 30 },
    SvcRq_InfoCardContent: {
      width: 220,
    },
    SvcRq_InfoCard_headingText: {
      fontFamily: "Inter",
      fontSize: 14,
      fontWeight: 600,
      letterSpacing: "0.28px",
      color: "#bd2d37",
      marginBottom: 10,
    },
    SvcRq_Body_row1: {
      height: 50,
    },

    SvcRq_Body_row1_headingTextHelper: {
      height: "50%",
      justifyContent: "center",
    },

    SvcRq_Body_row1_headingText: {
      fontFamily: "Inter",
      fontSize: 18,
      fontWeight: "bold",
      lineHeight: 1.17,
      color: "#5f5f5f",
    },

    SvcRq_Body_row1_bottomTextHelper: {
      height: "50%",
      justifyContent: "center",
    },

    SvcRq_Body_row1_bottomText: {
      fontFamily: "Inter",
      fontSize: 14,
      fontWeight: 300,
      color: "#757575",
      lineHeight: 20
    },
    overlayViewStyle: {
      position: "absolute",
      zIndex: 9999,
      backgroundColor: "rgba(52,52,52,0.9)",
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      borderRadius: 15,
    },
  },

  {
    [maxSize(DEVICE_SIZES.LG)]: {},

    [maxSize(DEVICE_SIZES.MD)]: {
      container: {
        height: "default",
      },
      contentViewStyle: {
        flexDirection: "column",
      },
      contentTwoStyle: {
        width: "100%",
      },
      SvcRq_InfoCard: {
        width: "default",
        height: "default",
        marginRight: 0,
        marginBottom: 20,
      },

      SvcRq_InfoCardContent: {
        width: "95%",
      },
    },

    [maxSize(DEVICE_SIZES.SM)]: {
      container: {
        marginLeft: 0,
        width: "100%",
      },
    },
    [maxSize(DEVICE_SIZES.XS)]: {
      container: {
        marginLeft: 0,
        height: 655,
      },
      contentTwoStyle: { width: "105%" },
      contentViewStyle: {
        flexDirection: "column",
      },
      overlayViewStyle: {
        position: "absolute",
        zIndex: 9999,
        backgroundColor: "rgba(52,52,52,0.9)",
        width: "100%",
        height: "100%",
        top: 0,
        left: 0,
        borderRadius: 15,
      },

      SvcRq_Body_row1: {
        height: 50,
      },

      SvcRq_Body_row1_headingTextHelper: {
        height: "50%",
        justifyContent: "center",
      },

      SvcRq_Body_row1_headingText: {
        fontFamily: "Inter",
        fontSize: 18,
        fontWeight: "bold",
        lineHeight: 1.17,
        color: "#5f5f5f",
      },

      SvcRq_Body_row1_bottomTextHelper: {
        height: "50%",
        justifyContent: "center",
      },

      SvcRq_Body_row1_bottomText: {
        fontFamily: "Inter",
        fontSize: 14,
        fontWeight: "300",
        lineHeight: 20,
        color: "#757575",
        marginTop: 10,
      },

      SvcRq_InfoCard: {
        height: 220,
        width: 260,
        paddingLeft: 10,
      },
      SvcRq_InfoCardContent: {
        width: 220,
      },
      SvcRq_InfoCard_headingText: {
        fontFamily: "Inter",
        fontSize: 14,
        fontWeight: "600",
        letterSpacing: 0.28,
        color: "#bd2d37",
        marginBottom: 10,
      },
    },
  }
);

//make this component available to the app
export default MobileNumberUpdate;
